import exp from '../../assets/images/our_story_years_exp.png';
import health from '../../assets/images/our_story_health_products.png';
import global from '../../assets/images/our_story_global.png';
import satisfied from '../../assets/images/our_story_satisfied_cust.png';

function Record() {
  return (
    <div className="about__record-container full-horizon">
      <div className="about__record-wrapper row">
        <div className="about__record-content background__gradient">
          <div className="about__record-box column">
            <img src={exp} alt="Years Experiences" />
            <h1>26</h1>
            <p>다년간의 경험</p>
          </div>
        </div>
        <div className="about__record-content background__gradient">
          <div className="about__record-box column">
            <img src={health} alt="Health Products" />
            <h1>22</h1>
            <p>다양한 제품</p>
          </div>
        </div>
        <div className="about__record-content background__gradient">
          <div className="about__record-box column">
            <img src={global} alt="Global Distributors" />
            <h1>17</h1>
            <p>국제적 판매처</p>
          </div>
        </div>
        <div className="about__record-content background__gradient">
          <div className="about__record-box column">
            <img src={satisfied} alt="Plus Satisfied Customers" />
            <h1>2000000</h1>
            <p>고객 만족 충족</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Record;